<i18n locale="en">
{
  "actions": {
    "order": "Order Now"
  },
  "labels": {
    "title": "Have you heard about our free rewards program?",
    "subtitle": "Unlock delicious food by ordering directly from us."
  },
  "reasons": {
    "0": "Earn points with every order",
    "1": "Purchase food with points",
    "2": "Receive exclusive discounts"
  }
}
</i18n>

<template>
  <PreviewSheet radius="0">
    <PreviewSheet
      class="loyalty-explainer-preview__heading"
      radius="0"
      background="secondary"
    >
      <OwnStack spacing="4">
        <PreviewTypographyLegacy
          :text="$t('labels.title')"
          variant="heading2"
        />
        <PreviewTypographyLegacy :text="$t('labels.subtitle')" />
      </OwnStack>
    </PreviewSheet>

    <PreviewSheet class="loyalty-explainer-preview__body" radius="0">
      <OwnStack spacing="10">
        <PreviewSheet background="secondary" border="divider">
          <OwnStack v-for="option of options" :key="option">
            <PreviewHr v-if="option !== 0" />
            <OwnStack class="loyalty-explainer-preview__item" spacing="2" row>
              <PhCheckCircle size="24" class="status-success" />
              <PreviewTypographyLegacy
                :text="$t(`reasons.${option}`)"
                color="primary"
              />
            </OwnStack>
          </OwnStack>
        </PreviewSheet>
        <PreviewButtonLegacy size="xsmall">
          <PreviewTypographyLegacy
            :text="$t('actions.order')"
            color="white"
            variant="buttonSmall"
          />
        </PreviewButtonLegacy>
      </OwnStack>
    </PreviewSheet>
  </PreviewSheet>
</template>

<script>
import { PhCheckCircle } from 'phosphor-vue/dist/phosphor-vue.esm'

import {
  PreviewButtonLegacy,
  PreviewHr,
  PreviewSheet,
  PreviewTypographyLegacy,
} from '@/lib/builder'

import { OwnStack } from '@/ui'

export default {
  name: 'LoyaltyExplainerPreview',
  components: {
    OwnStack,
    PhCheckCircle,
    PreviewButtonLegacy,
    PreviewHr,
    PreviewSheet,
    PreviewTypographyLegacy,
  },
  data() {
    return {
      options: [0, 1, 2],
    }
  },
}
</script>

<style lang="scss" scoped>
.loyalty-explainer-preview {
  &__heading {
    padding: 24px 40px 80px 40px;
  }

  &__body {
    padding: 40px;
  }

  &__item {
    padding: 16px;
  }
}
</style>
